module.exports = __webpack_public_path__ + "img/2024-05_impact.edcf656a.jpg";